import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Field as DefaultField } from "formik";
import { useTranslation } from "react-i18next";

import {
  parseStyle,
  useThemeProps,
  handleComponentsProp,
  Button,
  MaybeFragment,
} from "../../wsui/base";

import DefaultFormFieldDescription from "./FormFieldDescription.jsx";
import DefaultFormFieldError from "./FormFieldError.jsx";
import DefaultFormFieldLabel from "./FormFieldLabel.jsx";
import DefaultFormFieldWrapper from "./FormFieldWrapper.jsx";

const DefaultInputWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "style",
})`
  position: relative;
  ${({ style, theme }) => parseStyle(style, theme)}
`;

const DefaultSubmitButton = ({ ...props }) => {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Button
      color="white"
      css={css`
        display: flex;
        align-items: center;
        justify-content: center;
      `}
      // hoverStyle={{
      //   backgroundColor: "gray.200",
      // }}
      label={t("wsui.form.inputSubmitButtonLabel")}
      {...props}
    />
  );
};

export default function FormInputField(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "FormInputField" });
  props = useThemeProps({ props, name: "FormField" });
  let {
    inputProps = {},
    placeholder,
    components,
    rowGap = [1, 2],
    inputWrapperProps = {},
    ...restProps
  } = props;
  let {
    Field,
    FormFieldDescription,
    FormFieldError,
    FormFieldLabel,
    FormFieldWrapper,
    InputWrapper,
    SubmitButton,
  } = handleComponentsProp(components, {
    Field: DefaultField,
    FormFieldDescription: DefaultFormFieldDescription,
    FormFieldError: DefaultFormFieldError,
    FormFieldLabel: DefaultFormFieldLabel,
    FormFieldWrapper: DefaultFormFieldWrapper,
    InputWrapper: DefaultInputWrapper,
    SubmitButton: DefaultSubmitButton,
  });

  let {
    style,
    focusStyle,
    hoverStyle,
    borderRadius = 1,
    paddingBlock = 3,
    paddingInline = 3,
    ...restInputProps
  } = inputProps;

  return (
    <FormFieldWrapper
      // className={clsx(styles.component, className)}
      css={css`
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: ${theme.getLength(rowGap)};
      `}
      {...restProps}
    >
      {({ name, controlProps, wrapperProps, type, id }) => (
        <MaybeFragment {...wrapperProps}>
          <FormFieldLabel
          // className={styles.label}
          />
          <FormFieldDescription
          // className={styles.description}
          />
          <InputWrapper
            // className={styles.control}
            {...inputWrapperProps}
          >
            <Field
              type={type}
              // className={styles.input}
              name={name}
              css={css`
                width: 100%;
                padding-block: ${theme.getLength(paddingBlock)};
                padding-inline: ${theme.getLength(paddingInline)};
                box-sizing: border-box;
                border-radius: ${theme.getLength(borderRadius)};
                border: 1px solid ${theme.getColor(`border.300`)};
                box-shadow: none;
                font: inherit;
                color: inherit;
                ${parseStyle(style, theme)}
                &:focus {
                  ${parseStyle(focusStyle, theme)}
                }
                &:hover {
                  ${parseStyle(hoverStyle, theme)}
                }
              `}
              id={id}
              placeholder={placeholder}
              {...controlProps}
              {...restInputProps}
            />
            <SubmitButton
              type="submit"
              css={css`
                position: absolute;
                inset-block: 0;
                inset-inline-end: 0;
                margin: ${theme.getLength(1)};
                aspect-ratio: 1;
                height: calc(100% - 2 * ${theme.getLength(1)});
              `}
            />
          </InputWrapper>
          <FormFieldError
          // className={styles.error}
          />
        </MaybeFragment>
      )}
    </FormFieldWrapper>
  );
}
